<template>
    <main id="content" class="faq-content">
        <div class="container">
            <div class="link-page">
                <div class="breacrump">
                    <div
                        class="item-breacrump"
                        itemscope
                        itemtype="http://data-vocabulary.org/Breadcrumb"
                    >
                        <router-link to="/" class="link-home">
                            <span itemprop="title">{{ $t("app.Home") }}</span>
                        </router-link>
                        <span class="slashes-link">/</span>
                    </div>
                    <div
                        class="item-breacrump"
                        itemscope
                        itemtype="http://data-vocabulary.org/Breadcrumb"
                    >
                        <router-link to="/we-talk-about-us" itemprop="url">
                            <span itemprop="title">FAQ</span>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="text-center font-bai">
                <h1 class="font-balo font-bold">FAQ</h1>
                <div class="faq-question-container">
                    <div
                        class="faq-question-list col-md-6 offset-md-3"
                        id="accordion"
                        v-if="faq.length > 0"
                    >
                        <div
                            class="faq-question-element"
                            v-for="(item, index) in faq"
                            :key="index"
                        >
                            <b-button
                                v-b-toggle="`collapse-${item.ID}`"
                                class="faq-qe-title font-bold"
                                >{{ item.title }}</b-button
                            >
                            <b-collapse
                                :id="`collapse-${item.ID}`"
                                class="answer"
                                v-html="item.content"
                            ></b-collapse>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { get } from "lodash";
import { setDescriptionPage } from "@/helper/helper";
export default {
    name: "FAQPage",
    mounted() {
        this.getFAQ();
        let pageId = 247;
        if (this.lang === "en") {
            pageId = 365;
        }
        this.getPage(pageId).then(() => {
            setDescriptionPage(get(this.page, "acf.meta_description", ""));
        });
    },
    computed: {
        ...mapState({
            page: state => get(state, "app.page", {}),
            general: state => get(state, "app.general", {}),
            faq: state => get(state, "app.faq", [])
        })
    },
    methods: {
        ...mapActions("app", ["getFAQ", "getPage"])
    }
};
</script>
